const INDEED = 'indeed';
const BOOST = 'boost';
const SPRING = 'spring';
const REACH = 'reach';
const JOVEO = 'joveo';

export { BOOST, INDEED, JOVEO, REACH, SPRING };
